import { MutationTree } from 'vuex';
import { QuerySignalsState } from '../../models';
import { ClearQuerySignalsMutation } from './mutations/clear-query-signals.mutation';
import { SetLastNextQueryLoadedMutation } from './mutations/set-last-next-query-loaded.mutation';
import { SetQuerySignalsMutation } from './mutations/set-query-signals.mutation';
import { ToggleRelatedTagMutation } from './mutations/toggle-related-tag.mutation';
import { UpdateNextQueryMutation } from './mutations/update-next-query.mutation';

export const QUERY_SIGNALS_MUTATIONS: MutationTree<QuerySignalsState> = {
  ...new ClearQuerySignalsMutation().mutations,
  ...new UpdateNextQueryMutation().mutations,
  ...new ToggleRelatedTagMutation().mutations,
  ...new SetLastNextQueryLoadedMutation().mutations,
  ...new SetQuerySignalsMutation().mutations
};
